export default __webpack_public_path__ + "static/media/TV.8e650b89.png";